var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cases-card"
  }, [_c("section", {
    staticClass: "cases-card__left"
  }, [_c("img", {
    attrs: {
      src: require(`@/assets/images/logo/${_vm.icon}`),
      alt: ""
    }
  })]), _c("section", {
    staticClass: "cases-card__right"
  }, [_c("h5", {
    staticClass: "puhui-M"
  }, [_vm._v(_vm._s(_vm.title))]), _c("p", [_vm._v(_vm._s(_vm.desc))])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };